import React from "react";
import { Text } from "../typography";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { IconExternalLink } from "@amzn/stencil-react-components/icons";
import { I9_ADVANTAGE_URL } from "../../config/urls";

interface I9LegacyProps {
  onLinkClick: () => void;
}

export const I9Legacy = ({ onLinkClick }: I9LegacyProps) => {
  return (
    <Col gridGap="1rem">
      <Text>
        The I9 is a Federal requirement used to verify identity and employment
        authorization. You must complete your I-9 to begin work with Amazon. If
        you have been previously employed by Amazon, you may not need to
        complete the Form I-9 again unless you receive an email stating
        otherwise.
        <br />
        <p>
          To begin your I-9, click the link below and login using the following:
        </p>
        <ul className="task-details">
          <li>
            Employee Email Address: The same email address used for this
            application
          </li>
          <li>PIN: The last four numbers of your Social Security Number</li>
        </ul>
        <p>
          If you do not yet have an SSN, you can still access the Form I9 using
          the alternate link and directions in the email sent by{" "}
          <a href="https://i9advantage.com/">I9advantage.com</a>.
        </p>
      </Text>
      <Link href={I9_ADVANTAGE_URL} target="_blank" fontSize="T200">
        <Row alignItems="center" gridGap="0.2rem" onClick={onLinkClick}>
          <IconExternalLink />
          Complete Form I-9
        </Row>
      </Link>
    </Col>
  );
};
